import { Layout } from "antd";
import React, { useRef } from "react";
import AppSidebarLayout from "./AppSidebar";
import styled from "styled-components";
import COLORS from "../../common/Colors";
import SideBar from "./Sidebar";
import { Outlet } from "react-router-dom";
import Header from "./Header";

const { Content } = Layout;

const StyledContent = styled(Content)`
  height: 91vh;
  background-color: #ffffff;
  padding: 20px 10px;
  /* overflow-y: auto; */
  overflow: auto;
  ${({ isloading }) => isloading === "true" && `text-align: center;`}
  .initial-loader {
    margin-top: 100px;
    color: ${COLORS.grey};
  }
  ${({ nopadding }) =>
    nopadding === "true" && `padding: 0px !important; border: none`}
 
`;

const MainLayout = () => {
  const layoutRef = useRef(null);
  const sidebarRef = useRef(null);
  return(
    <>
      <Layout ref={layoutRef}>
        <Layout.Sider ref={sidebarRef} width={70}>
          <AppSidebarLayout />
        </Layout.Sider>

        <Layout>
          <Header />
          <Layout>
            <SideBar />
            <StyledContent>
              <Outlet />
            </StyledContent>
          </Layout>
        </Layout>
      </Layout>
    </>
  )
}

export default MainLayout;